import { render } from "./EditParametersModal.vue?vue&type=template&id=68bb9406"
import script from "./EditParametersModal.vue?vue&type=script&lang=js"
export * from "./EditParametersModal.vue?vue&type=script&lang=js"

import "./EditParametersModal.vue?vue&type=style&index=0&id=68bb9406&lang=css"
script.render = render

export default script